module.exports = __webpack_public_path__ + "img/pic-1.d59b584e.png";